import {CommonResponse, BaseRequestParams, GetParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {UinRequest} from "../models/request/UinRequest"
import {UinListsResponse, UinResponse} from "../models/response"
import {UinListsFilterQuery} from "../store/uinListReducer"

const endpoint = "PSLeakDeviceUin"

export const uinListApi = {
    getUinList(params?: GetParamsType & UinListsFilterQuery): Promise<CommonResponse<UinListsResponse>>
    {
        const paramsString = filterToString(params)
        return instance.get(`${endpoint}${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createUin(form: CreateUin): Promise<CommonResponse<UinResponse>>
    {
        const {controller, ...rest} = form
        return instance.post(`${endpoint}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteUin(form: DeleteUin): Promise<CommonResponse<boolean>>
    {
        const {id, controller} = form

        let query = id.map(i => `id=${i}`).join('&')

        return instance.delete(`${endpoint}?${query}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type CreateUin = UinRequest & BaseRequestParams

export type DeleteUin = {
    id: number[]
} & BaseRequestParams